module.exports = "//static.hsappstatic.net/LoginUI/static-1.7622/img/ms-logo.png"